import client from "../../client/client";

class ProjectCategoryService {
	setCompanyVersion({ projectId, versionId }, cancelToken) {
		return client.put(`/projects/${projectId}/company-versions/${versionId}`, { config: { cancelToken } });
	}
}

export default new ProjectCategoryService();
